import { ThemeOptions } from '@mui/material-hidden';

import { colors, type MainColor } from './colors';
import { elevation } from './elevation';

export type { Elevation } from './elevation';
export type { Colors, MainColor } from './colors';

export const getPalette = (): ThemeOptions['palette'] =>
  ({
    colors,
    elevation,
    secondary: {
      main: colors.coolGrey60,
    },
    action: {
      active: colors.forest60,
    },
    primary: {
      // default color
      main: colors.navy80,
      // hover
      dark: colors.navy70,
    },
    success: {
      main: colors.forest50,
    },
    text: {
      primary: colors.navy95,
      secondary: colors.coolGrey60,
      secondaryDarker: colors.coolGrey70,
    },
    // warning: {},
    // error: {},
    // info: {},
    // common: {},
    hexToRGB(color: string, alpha?: number): string {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      } else {
        return `rgb(${r}, ${g}, ${b})`;
      }
    },
    getColor(color: MainColor): string {
      return colors[color];
    },
    getColors(requestedColors: MainColor[]): string[] {
      return requestedColors.map((color) => colors[color]);
    },
  }) as ThemeOptions['palette'];
